import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reverse";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import * as FieldComponents from "@Shared/components/sections/index";
import { ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP } from "../../../../store/application-actions";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { RESET_MORTGAGE_INFORMATION, CHANGE_MORTGAGE_INDEX, UPDATE_QUALIFYING_INTEREST_RATE, MIRROR_SUBMISSION_AND_QUALIFYING, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE, SET_APPLICANT_MORTGAGE_EXCLUSION } from "../../../../store/application-mutations";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import QualifyingDetails from "./qualifying-details";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import ApplicantMixin from "@Broker/@Modules/clients/applications/application/select-options/applicant-mixin";
import SelectOptionsMixin from "@Broker/@Modules/clients/applications/application/select-options/select-options-utils-mixin";
import { LOAD_LENDERS } from "../../../../store/lender-submit-actions";
const {
  mapFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
import { DEFAULT_AMORTIZATION_YEARS_VALUE } from "@Shared/@Utils/application-defaults-utils/application-default-values-constants";
import { findIndex, isEmpty, kebabCase, mapValues } from "lodash";
import { ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE } from "../../../../store/lender-submit-getters";
import { validSignedNumber } from "@Shared/@Utils/validation-rules";
import { validationMixin } from "vuelidate";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { PagesVisibilityMap } from "@Broker/@Utils/application/pages-visibility-map.ts";
import MultipleVisibilityButton from "@Broker/@Modules/clients/applications/application/components/pages-components/application/util-components/multiple-visibility-button.vue";
import { defineComponent } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import { GenericModal } from "@Shared/components/modals";
export default defineComponent({
  name: "SubmissionDetails",
  components: _objectSpread(_objectSpread({
    QualifyingDetails
  }, FieldComponents), {}, {
    Select2,
    InlinePrompt,
    MultipleVisibilityButton,
    GenericModal
  }),
  mixins: [validationMixin, DuplicatorMixin, VisibilityToggleMixin, MortgageDetailsMixin, ApplicantMixin, SelectOptionsMixin],
  validations: {
    variableToPrime: {
      validSignedNumber
    },
    discountRate: {
      validForNetRate: function () {
        return this.isValidForNetRate("discountRate");
      }
    },
    buyDownRate: {
      validForNetRate: function () {
        return this.isValidForNetRate("buyDownRate");
      }
    }
  },
  props: {
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    pathName: {
      type: String,
      default: ""
    },
    mortgageIndexSelector: {
      type: Number,
      default: 1
    },
    currentMortgageType: {
      type: String,
      default: ""
    },
    calculatedValues: {
      type: Object,
      default: () => ({})
    },
    submissionDetailsLength: {
      type: Number,
      default: 0
    },
    currentMortgageData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loadingLenders: false,
      lastRateEdited: null,
      wasNetRateValid: true,
      PagesVisibilityMap
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    lenders(state) {
      const curLenderValue = this.lender;
      let stateLendersData = state.lenders;
      let lenderOptions = [{
        label: "",
        value: "",
        mtgProductId: ""
      }];
      for (const lenderData of stateLendersData) {
        const {
          enabled,
          label,
          value,
          mtgProductId
        } = lenderData;
        if (enabled || value === curLenderValue) lenderOptions.push({
          label,
          value,
          mtgProductId
        });
      }
      return lenderOptions;
    },
    applicantSubmissionExclusion(state) {
      const {
        currentApplicationId
      } = state;
      const currentApplication = state.applications.byId[currentApplicationId] || {};
      const applicantSubmissionExclusion = currentApplication["submission-details"][this.mortgageIndexSelector]["applicant-submission-exclusion"];
      return applicantSubmissionExclusion != null ? applicantSubmissionExclusion : [];
    }
  })), mapGetters("ApplicationStore", [ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE])), {}, {
    anyAcceptedLenderSubmission() {
      return !isEmpty(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE);
    },
    applicantsForMortgageSelection() {
      var _this$currentApplicat, _this$currentApplicat2, _this$currentApplicat3, _context;
      const allApplicants = [this.currentApplication["main-applicant"], ...((_this$currentApplicat = this.currentApplication) != null && (_this$currentApplicat2 = _this$currentApplicat["main-applicant"]) != null && (_this$currentApplicat3 = _this$currentApplicat2["personal-details"]) != null && _this$currentApplicat3["coapp"] ? _filterInstanceProperty(_context = this.currentApplication["co-applicants"]).call(_context, applicant => applicant.id) : [])];
      const applicantTypeValueToLabel = this.invertLabelValueMap(this.coapplicantTypeOptions);
      const applicantSalutationValueToLabel = this.invertLabelValueMap(this.salutationOptions);
      return _mapInstanceProperty(allApplicants).call(allApplicants, (applicant, index) => {
        var _applicant$id, _applicantSalutationV, _applicantTypeValueTo;
        return {
          id: (_applicant$id = applicant.id) != null ? _applicant$id : "",
          fullName: `${(_applicantSalutationV = applicantSalutationValueToLabel[applicant["personal-details"].salutation]) != null ? _applicantSalutationV : ""} ${applicant["personal-details"]["first-name"]} ${applicant["personal-details"]["last-name"]}`,
          applicantType: index == 0 ? this.$t("application-form.main-applicant") : (_applicantTypeValueTo = applicantTypeValueToLabel[applicant["personal-details"]["co-applicant-type"]]) != null ? _applicantTypeValueTo : this.$t("application-form.co-applicant")
        };
      });
    },
    disabledByAcceptedSubmissionInputByMortgage() {
      var _context2;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context2 = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context2, (acc, mortgageType) => {
        acc[mortgageType] = true;
        return acc;
      }, {});
    },
    disabledByAcceptedSubmissionIconByMortgage() {
      var _context3;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context3 = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context3, (acc, mortgageType) => {
        acc[mortgageType] = "fa-info-circle";
        return acc;
      }, {});
    },
    disabledByAcceptedSubmissionTooltipTextByMortgage() {
      var _context4;
      if (!this.anyAcceptedLenderSubmission) return {};
      return _reduceInstanceProperty(_context4 = _Object$keys(this.ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE)).call(_context4, (acc, mortgageType) => {
        acc[mortgageType] = this.$t("application-flow.messages.disabled-by-accepted-submission");
        return acc;
      }, {});
    },
    paths() {
      const root = this.pathName;
      const submission = `${root}[submission-details]`;
      const classifications = `${root}[mortgage-classifications]`;
      return {
        lender: submission,
        mortgageType: submission,
        loanType: submission,
        interestAdjustmentDate: submission,
        firstPaymentDate: submission,
        maturityDate: submission,
        interestAdjustmentAmount: submission,
        lineOfBusiness: submission,
        progressAdvance: submission,
        amortizationMonths: submission,
        amortizationYears: submission,
        blendedAmortization: submission,
        buyDownRate: submission,
        variableToPrime: submission,
        compoundedPeriod: submission,
        insured: submission,
        includeInMortgage: submission,
        premiumRate: submission,
        interestRate: submission,
        discountRate: submission,
        rateType: submission,
        locRepaymentType: submission,
        miPremiumOverride: submission,
        miPremiumRate: submission,
        miPremiumAmount: submission,
        termType: submission,
        frequency: submission,
        termYears: submission,
        termMonths: submission,
        interestOnly: submission,
        commercial: classifications,
        construction: classifications,
        reverse: classifications,
        subprime: classifications,
        heloc: classifications,
        qualifiedSyndicated: classifications,
        nonQualifiedSyndicated: classifications,
        bridgeloan: classifications,
        suspicioustransaction: classifications
      };
    },
    mortgageIndexTitle() {
      return this.currentMortgageType ? `${this.$t("application-form")[this.currentMortgageType]} ${this.$t("application-form.mortgage")}` : this.$t("application-form.fill-mortgage-type-message");
    },
    tiedSubmissionDetailsIndex() {
      return findIndex(this.currentApplication["submission-details"], ({
        "submission-details": submission
      }) => submission["mortgage-type"] === this.currentMortgageType);
    },
    currentMortgageIndex() {
      return MORTGAGE_TYPE_PARSER[this.currentMortgageType] || 0;
    },
    filteredMortgageTypeOptions() {
      var _context5, _context6;
      const currentMortgageTypes = _mapInstanceProperty(_context5 = this.currentApplication["submission-details"]).call(_context5, submissionInfo => submissionInfo["submission-details"]["mortgage-type"]);
      return _mapInstanceProperty(_context6 = this.mortgageTypeOptions).call(_context6, option => _objectSpread(_objectSpread({}, option), {}, {
        disabled: _includesInstanceProperty(currentMortgageTypes).call(currentMortgageTypes, option.value)
      }));
    },
    visibilityPaths() {
      return mapValues(this.paths, (path, key) => `${path}[${kebabCase(key)}]`);
    }
  }, mapFields("ApplicationStore", {
    closingDate() {
      return this.paths.closingDate;
    },
    financingWaiver() {
      return this.paths.financingWaiver;
    },
    purpose() {
      return this.paths.purpose;
    },
    lender() {
      return this.paths.lender;
    },
    mortgageType() {
      return this.paths.mortgageType;
    },
    loanType() {
      return this.paths.loanType;
    },
    interestAdjustmentDate() {
      return this.paths.interestAdjustmentDate;
    },
    firstPaymentDate() {
      return this.paths.firstPaymentDate;
    },
    maturityDate() {
      return this.paths.maturityDate;
    },
    interestAdjustmentAmount() {
      return this.paths.interestAdjustmentAmount;
    },
    lineOfBusiness() {
      return this.paths.lineOfBusiness;
    },
    progressAdvance() {
      return this.paths.progressAdvance;
    },
    amortizationMonths() {
      return this.paths.amortizationMonths;
    },
    amortizationYears() {
      return this.paths.amortizationYears;
    },
    blendedAmortization() {
      return this.paths.blendedAmortization;
    },
    buyDownRate() {
      return this.paths.buyDownRate;
    },
    variableToPrime() {
      return this.paths.variableToPrime;
    },
    compoundedPeriod() {
      return this.paths.compoundedPeriod;
    },
    insured() {
      return this.paths.insured;
    },
    includeInMortgage() {
      return this.paths.includeInMortgage;
    },
    premiumRate() {
      return this.paths.premiumRate;
    },
    interestRate() {
      return this.paths.interestRate;
    },
    discountRate() {
      return this.paths.discountRate;
    },
    rateType() {
      return this.paths.rateType;
    },
    locRepaymentType() {
      return this.paths.locRepaymentType;
    },
    miPremiumOverride() {
      return this.paths.miPremiumOverride;
    },
    miPremiumRate() {
      return this.paths.miPremiumRate;
    },
    miPremiumAmount() {
      return this.paths.miPremiumAmount;
    },
    termType() {
      return this.paths.termType;
    },
    frequency() {
      return this.paths.frequency;
    },
    termYears() {
      return this.paths.termYears;
    },
    termMonths() {
      return this.paths.termMonths;
    },
    interestOnly() {
      return this.paths.interestOnly;
    },
    commercial() {
      return this.paths.commercial;
    },
    construction() {
      return this.paths.construction;
    },
    reverse() {
      return _reverseInstanceProperty(this.paths);
    },
    subprime() {
      return this.paths.subprime;
    },
    heloc() {
      return this.paths.heloc;
    },
    qualifiedSyndicated() {
      return this.paths.qualifiedSyndicated;
    },
    nonQualifiedSyndicated() {
      return this.paths.nonQualifiedSyndicated;
    },
    bridgeloan() {
      return this.paths.bridgeloan;
    },
    suspicioustransaction() {
      return this.paths.suspicioustransaction;
    },
    purchasePrice() {
      return this.paths.purchasePrice;
    },
    estimatedValue() {
      return this.paths.estimatedValue;
    },
    appraisedValue() {
      return this.paths.appraisedValue;
    },
    propertyValueIndex() {
      return this.paths.propertyValueIndex;
    }
  })), {}, {
    classificationsData() {
      const {
        t
      } = useI18n();
      return [{
        name: "commercial",
        title: t("application-form.commercial")
      }, {
        name: "construction",
        title: t("application-form.construction")
      }, {
        name: "reverse",
        title: t("application-form.reverse")
      }, {
        name: "subprime",
        title: t("application-form.subPrime")
      }, {
        name: "heloc",
        title: "HELOC"
      }, {
        name: "qualified-syndicated",
        path: "qualifiedSyndicated",
        title: t("application-form.qualified-syndicated")
      }, {
        name: "non-qualified-syndicated",
        path: "nonQualifiedSyndicated",
        title: t("application-form.non-qualified-syndicated")
      }, {
        name: "bridgeloan",
        title: t("application-form.bridge-loan")
      }, {
        name: "suspicioustransaction",
        title: t("application-form.suspicious-transaction")
      }];
    },
    atLeastOneRequestedMortgage() {
      const {
        mortgages
      } = this.currentApplication["mortgage-details"];
      return mortgages.some(mortgage => mortgage.requested === "requested");
    },
    mortgageTypePlaceholder() {
      return !this.atLeastOneRequestedMortgage ? this.$t("application-form.need-request-mortgage") : this.$t("application-form.mortgage-type");
    },
    currentMortgageValue() {
      return this.currentMortgageData.amount;
    },
    computedMiPremiumRate: {
      get() {
        return this.miPremiumOverride ? this.miPremiumRate : this.calculatedValues.miPremiumRate;
      },
      set(value) {
        this.miPremiumRate = value;
        if (this.currentMortgageValue) this.miPremiumAmount = _parseFloat(value) * this.currentMortgageValue / 100;
        this.$emit("save");
      }
    },
    computedMiPremiumAmount: {
      get() {
        return this.miPremiumOverride ? this.miPremiumAmount : this.calculatedValues.miPremiumAmount;
      },
      set(value) {
        this.miPremiumAmount = value;
        if (this.currentMortgageValue) this.miPremiumRate = _parseFloat(value) / this.currentMortgageValue * 100;
        this.$emit("save");
      }
    },
    select2Options() {
      return {
        dropdownParent: `#submission-details-${this.currentMortgageIndex}`,
        closeOnSelect: true,
        language: {
          noResults() {
            return "No Lenders Found";
          }
        }
      };
    },
    termYearsAndMonths: {
      get() {
        const yearsToMonths = _parseInt(this.termYears || 0) * 12;
        return _parseInt(this.termMonths || 0) + yearsToMonths;
      },
      set(monthsCount) {
        this.termYears = Math.floor(_parseInt(monthsCount) / 12).toString();
        this.termMonths = (monthsCount % 12).toString();
      }
    },
    amortizationYearsAndMonths: {
      get() {
        const yearsToMonths = _parseInt(this.amortizationYears || 0) * 12;
        return _parseInt(this.amortizationMonths || 0) + yearsToMonths;
      },
      set(monthsCount) {
        this.amortizationYears = Math.floor(_parseInt(monthsCount) / 12).toString();
        this.amortizationMonths = (monthsCount % 12).toString();
      }
    },
    netRate() {
      return this.calculatedValues.netRate;
    }
  }),
  watch: {
    interestRate(value) {
      const qualifyingInterestRate = _parseFloat(this.currentApplication["submission-details"][this.mortgageIndexSelector]["qualifying-details"]["interest-rate"]);
      if (!qualifyingInterestRate || _parseFloat(value) > qualifyingInterestRate) {
        this.UPDATE_QUALIFYING_INTEREST_RATE({
          submissionIndex: this.mortgageIndexSelector,
          value
        });
      }
    },
    amortizationYears(value) {
      this.MIRROR_SUBMISSION_AND_QUALIFYING({
        value,
        submissionIndex: this.tiedSubmissionDetailsIndex,
        key: "amortization-years"
      });
    },
    amortizationMonths(value) {
      this.MIRROR_SUBMISSION_AND_QUALIFYING({
        value,
        submissionIndex: this.tiedSubmissionDetailsIndex,
        key: "amortization-months"
      });
    },
    interestOnly(value) {
      this.MIRROR_SUBMISSION_AND_QUALIFYING({
        value,
        submissionIndex: this.tiedSubmissionDetailsIndex,
        key: "interest-only"
      });
      this.MIRROR_SUBMISSION_AND_QUALIFYING({
        value: value === false ? DEFAULT_AMORTIZATION_YEARS_VALUE : "0",
        submissionIndex: this.tiedSubmissionDetailsIndex,
        key: "amortization-years"
      });
      if (value) {
        this.amortizationYears = "0";
        this.amortizationMonths = "0";
      }
    },
    loanType(value) {
      this.interestOnly = value !== "mortgage";
    },
    rateType(value) {
      this.variableToPrime = value == "fixed" ? null : this.variableToPrime;
    },
    netRate(value) {
      if (value < 0) {
        this.wasNetRateValid = false;
        this[this.lastRateEdited] = "0.000";
        this.handleSave();
      }
    },
    // Recalculate premium when mortgage value is changed
    currentMortgageValue() {
      this.computedMiPremiumRate = this.miPremiumRate;
    }
  },
  async mounted() {
    this.loadingLenders = true;
    await this.LOAD_LENDERS({
      all: true,
      applicationId: this.currentApplication["applicationId"]
    });
    this.loadingLenders = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP, LOAD_LENDERS])), mapMutations("ApplicationStore", [RESET_MORTGAGE_INFORMATION, CHANGE_MORTGAGE_INDEX, CHANGE_MORTGAGE_INDEX, UPDATE_QUALIFYING_INTEREST_RATE, MIRROR_SUBMISSION_AND_QUALIFYING, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE, SET_APPLICANT_MORTGAGE_EXCLUSION])), {}, {
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleDuplicate({
      what,
      where
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where
      });
      this.$emit("save");
    },
    handleRemoveSubmission(index, removePath) {
      const mortgageInformationStructure = this.getStructure(this.currentApplication["mortgage-details"].mortgages[0]);
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      const tiedMortgage = this.currentApplication["mortgage-details"].mortgages[this.currentMortgageIndex];
      if (tiedMortgage && tiedMortgage.requested === "requested") {
        this.RESET_MORTGAGE_INFORMATION({
          index: this.currentMortgageIndex,
          structure: _objectSpread(_objectSpread({}, mortgageInformationStructure), {}, {
            amount: 0
          })
        });
      }
      this.$emit("save");
    },
    handleRemove(index, removePath) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      this.$emit("save");
    },
    changeMortgageIndex(newMortgageType) {
      this.CHANGE_MORTGAGE_INDEX({
        currentMortgageType: this.currentMortgageType,
        newMortgageType
      });
      if (newMortgageType) {
        this.SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE({
          page: "property",
          triggerOnSave: true
        });
      }
      this.$emit("save");
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, ({
        label,
        value
      }) => {
        return {
          text: label,
          id: value
        };
      });
    },
    changeLender({
      id
    }) {
      this.lender = id;
      this.$emit("save");
      this.$emit("change");
    },
    handleSave() {
      this.$emit("save");
    },
    handleChangeRates(lastRateEdited) {
      this.lastRateEdited = lastRateEdited;
      this.wasNetRateValid = true;
    },
    isValidForNetRate(currentRate) {
      return this.lastRateEdited !== currentRate || this.wasNetRateValid;
    },
    toggleApplicantSubmissionExclusion(applicantId) {
      const newSubmissionExclusion = this.applicantSubmissionExclusion ? [...this.applicantSubmissionExclusion] : [];
      const applicantIndex = _indexOfInstanceProperty(newSubmissionExclusion).call(newSubmissionExclusion, applicantId);
      if (applicantIndex >= 0) {
        _spliceInstanceProperty(newSubmissionExclusion).call(newSubmissionExclusion, applicantIndex, 1);
      } else {
        newSubmissionExclusion.push(applicantId);
      }
      this.SET_APPLICANT_MORTGAGE_EXCLUSION({
        submissionIndex: this.mortgageIndexSelector,
        value: newSubmissionExclusion
      });
    },
    isApplicantAssociatedToMortgage(applicantId) {
      var _context7;
      return !_includesInstanceProperty(_context7 = this.applicantSubmissionExclusion).call(_context7, applicantId);
    },
    getClassification(classification, mortgageSelectionIndex) {
      var _this$currentApplicat4, _this$currentApplicat5, _this$currentApplicat6, _this$currentApplicat7;
      return !!((_this$currentApplicat4 = this.currentApplication) != null && (_this$currentApplicat5 = _this$currentApplicat4["submission-details"]) != null && (_this$currentApplicat6 = _this$currentApplicat5[mortgageSelectionIndex]) != null && (_this$currentApplicat7 = _this$currentApplicat6["mortgage-classifications"]) != null && _this$currentApplicat7[classification.name]);
    },
    setClassification(val, classification) {
      switch (classification.name) {
        case "commercial":
          this.commercial = val;
          break;
        case "construction":
          this.construction = val;
          break;
        case "reverse":
          this.reverse = val;
          break;
        case "subprime":
          this.subprime = val;
          break;
        case "heloc":
          this.heloc = val;
          break;
        case "qualified-syndicated":
          this.qualifiedSyndicated = val;
          break;
        case "non-qualified-syndicated":
          this.nonQualifiedSyndicated = val;
          break;
        case "bridgeloan":
          this.bridgeloan = val;
          break;
        case "suspicioustransaction":
          this.suspicioustransaction = val;
          if (val) this.$refs.suspiciousTransactionModal.show();
          break;
      }
    }
  })
});